'use strict';
var windowWidth = $(window).width();
var searchComponent = require('base/search/search');

// for mobile slider
if (window.innerWidth <= 768) {
    $('.plp-product-carousel-area').carousel(0);
    $('.plp-product-carousel-area').carousel('pause');
} else {
    $(document).on('mouseenter', '.plp-product-carousel-area', function () {
        $(this).carousel('cycle');
        $(this).addClass('cycleStarted');
        $('.plp-product-carousel-area').find('.carousel-inner a').attr('target','_blank');
    });
    $(document).on('mouseleave', '.plp-product-carousel-area', function () {
        if($(this).hasClass('cycleStarted'))
        {
            $(this).carousel(0);
            $(this).carousel('pause');
            $(this).removeClass('cycleStarted')
        }
        $('.plp-product-carousel-area').find('.carousel-inner a').removeAttr('target');
    });
}

/* eslint-disable no-underscore-dangle */
/* eslint-disable radix */

const { customSelectBox } = require('../customSelect');

const URL_PARAM_PAGE = 'page';
var isClicked = false;
var viewSize = window.screen.width;

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */

function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    var productLength = $('#js-error-page').val();
    $('.mobile-sort-by-list li:first-child').addClass('selected');
    $('.mobile-sort-by-list li:first-child').find('i').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
    
    if(productLength == 0 ) {
        $('.refinement-bar, .secondary-bar').hide();
        $('.js-result-block').removeClass('col-lg-9').addClass('col-lg-12');
        $('.plp-page-number').next().addClass('d-block');
        $('.js-result-block .promotions').addClass('row');
        if (viewSize <= 992) {
            $('.modal-background').remove();
            $('.plp-mobile-footer').hide();
        }
    } else {
        $('.refinement-bar, .secondary-bar').removeClass('d-none');
        $('.js-result-block').addClass('col-lg-9').removeClass('col-lg-12');
        $('.plp-page-number').next().removeClass('d-block');
        $('.js-result-block .promotions').removeClass('row');
        if (viewSize <= 992) {
            $('.plp-mobile-footer').show();
        }
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.results-search-count',
        '.plp-header'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function showContentTab() {
    // Display content results from the search
    $('.container').on('click', '.content-search', function () {
        if ($('#content-search-results').html() === '') {
            getContent($(this), $('#content-search-results'));
        }
    });

    // Display the next page of content results from the search
    $('.container').on('click', '.show-more-content button', function () {
        getContent($(this), $('#content-search-results'));
        $('.show-more-content').remove();
        $('.loadmoreproducts').remove();
    });
}

/**
 * Get URL params
 * @param {string} url - url
 * @param {string} param - param
 * @return {undefined}
 */
function getUrlParameterValue(url, param) {
    var index = url.indexOf('?');
    if (index > 0) {
        var u = url.substring(index + 1).split('&');
        var params = new Array(u.length);

        for (var i = 0; i < u.length; i++) {
            params[i] = u[i].split('=');
            if (params[i][0] === param) {
                return params[i][1];
            }
        }
    }
    return null;
}


/**
 * Update URL params
 * @param {string} url - url
 * @param {string} param - param
 * @param {string} value - param
 * @return {undefined}
 */
function updateUrlParameter(url, param, value) {
    var index = url.indexOf('?');
    if (index > 0) {
        var u = url.substring(index + 1).split('&');
        var params = new Array(u.length);
        var found = false;
        for (let i = 0; i < u.length; i++) {
            params[i] = u[i].split('=');
            if (params[i][0] === param) {
                params[i][1] = value;
                found = true;
            }
        }

        if (!found) {
            params.push(new Array(2));
            params[params.length - 1][0] = param;
            params[params.length - 1][1] = value;
        }

        var res = `${url.substring(0, index + 1) + params[0][0]}=${params[0][1]}`;
        for (var i = 1; i < params.length; i++) {
            res += `&${params[i][0]}=${params[i][1]}`;
        }
        return res;
    }
    return `${url}?${param}=${value}`;
}

function sort() {
    // Handle sort order menu selection
    $(document).on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        let url = $('#customerNoUrl').val();
        let customerId = "";
        $.ajax({
            url,
            type: 'get',
            success(data) {
                if (data.customerId) {
                    customerId = data.customerId;
                }
            },
            error() {
                console.error('Error fetching content:', error);
            },
        });
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success(response) {
                var filterData = $($.parseHTML(response)).filter(".searchAjaxGAFilter");
                    var filterDataGA = JSON.parse(filterData.text());
                    if(filterDataGA){
                        filterDataGA.currentPage = window.location.href;
                        filterDataGA.user_id = customerId;
                        filterDataGA.nextPage = window.location.href;
                        filterDataGA.event = "Filter_Sorted";
                        window.dataLayer.push(filterDataGA);
                    }
                $('.product-grid').empty().html(response);
                $.spinner().stop();
            },
            error() {
                $.spinner().stop();
            },
        });
    });

}


function showMore() {
    // Show more products
    $(document).on('click', '#more-load', function (e) {
        var plpPageNo = $('.plp-page-number').val();
        if (plpPageNo !== '0') {
            if (!isClicked) {
                isClicked = true;
                e.stopPropagation();
                var showMoreUrl = $(this).data('url');
                e.preventDefault();

                $.spinner().start();
                $(this).trigger('search:showMore', e);
                $.ajax({
                    url: showMoreUrl,
                    async: false,
                    data: { selectedUrl: showMoreUrl },
                    method: 'GET',
                    success(response) {
                        $('.grid-footer').replaceWith(response);
                        //updateWishlistonPLP();
                        updateSortOptions(response);
                        //  update page number in URL
                        var currVal = getUrlParameterValue(window.location.href, URL_PARAM_PAGE);
                        if (!currVal) currVal = 0;
                        var newUrl = updateUrlParameter(window.location.href, URL_PARAM_PAGE, parseInt(currVal, 10) + 1);
                        history.pushState({}, '', newUrl);
                        $.spinner().stop();
                    },
                    error() {
                        $.spinner().stop();
                    },
                });
            }
            setTimeout(() => {
                isClicked = false;
            }, 3000);
        } else {
            $('.plp-page-number').val('1');
        }
    });
}


function applyFilter() {
  
    // Handle refinement value selection and reset click
    $(document).on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .no-product-reset, .filter-value button, .swatch-filter button, .refinementsQuick button, .price-block .js-btn-price-filter',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            var seoHref = $(this).data('seo-href');
            var currentDomain = window.location.origin;
            var newCanonicalUrl = currentDomain + seoHref;
            $('link[rel="canonical"]').attr('href', newCanonicalUrl);
            
            if($(this).hasClass('js-btn-price-filter')) {
                var validationStatus = validatePriceRange();
                if(!validationStatus){
                    return false;
                }                
            }
            $.spinner().start();
            $(this).trigger('search:filter', e);
            
            var searchUrl = $(this).data('href');
            var seoUrl = $(this).data('seo-href') || searchUrl;
            if (seoUrl) {
                window.history.pushState({}, null, seoUrl);
            }

            var attributeId = `#${$(this).find('span').last().attr('id')}`;
            var name = $(this).data('name');
            let url = $('#customerNoUrl').val();
            let customerId = "";
            $.ajax({
                url,
                type: 'get',
                success(data) {
                    if (data.customerId) {
                        customerId = data.customerId;
                    }
                },
                error() {
                    console.error('Error fetching content:', error);
                },
            });
            $.ajax({
                url: searchUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: searchUrl,
                },
                method: 'GET',
                success(response) {
                    parseResults(response);
                    var filterData = $($.parseHTML(response)).filter(".searchAjaxGAFilter");
                    var filterDataGA = JSON.parse(filterData.text());
                    if(filterDataGA){
                        filterDataGA.click_text = name;
                        filterDataGA.currentPage = window.location.href;
                        filterDataGA.user_id = customerId;
                        filterDataGA.nextPage = window.location.href;
                        filterDataGA.event = "Filter_Option";
                        window.dataLayer.push(filterDataGA);
                    }

                    var success =  $($.parseHTML(response)).filter(".searchAjaxGA"); 
                    var searchAjaxDataGA = JSON.parse(success.text());
                    window.dataLayer.push(searchAjaxDataGA);
                    customSelectBox();
                    $.spinner().stop();
                    if (window.innerWidth > 992) {
                        $(window).scrollTop(0)
                    }
                    let elements = $('.refinements .card.active');
                    elements.find('.title.btn-link').removeClass('collapsed');
                    elements.find('.filler-content').addClass('collapse').addClass('show');
                    $(attributeId).parent('button').focus();
                    if (!$('.refinement-size').hasClass('active')) {
                        $('.refinement-size').find('button.title').addClass('collapsed');
                    }
                    if ($('.secondary-bar.selected-list-box button.reset').length) {
                        $('.no-product-reset').addClass('d-none');
                    }
                    if (!$('.secondary-bar.selected-list-box button.reset').length) {
                        $('.refinementsQuick').removeClass('d-none');
                    }
                    let elem = $(document).find('.refinementsQuick .btn-quickfilter .filtertext.selected');
                    if (elem.length) elem.parent().css('border-color', '#000');
                    $('.header-bar .close.js-clear-all').show();
                },
                error() {
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                },
            });
        });
}
function resize () {
    // Close refinement bar and hide modal background if user resizes browser
    $(window).on('resize', function () {
        var refinement_bar = $('.refinement-bar');
        if( windowWidth != $(window).width()) {
            $('.refinement-bar, .modal-background').hide();
            refinement_bar.siblings().attr('aria-hidden', false);
            refinement_bar.closest('.row').siblings().attr('aria-hidden', false);
            refinement_bar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            refinement_bar.closest('.container.search-results').siblings().attr('aria-hidden', false);
        }
    });
}
function clickEvents() {

    // start sub category fixed top on scroll up
    var prevScrollpos = window.pageYOffset;
    var categoriesContainer = $(".categories-container");
    $(window).scroll(function () {
        const currentScrollPos = window.pageYOffset;
        let iscategoryImageInViewPort = $('.category-search-results').isInViewport();
        setTimeout(() => {
            if ((prevScrollpos > currentScrollPos)) {
                // Scrolling up
                categoriesContainer.removeClass("hide-on-scroll-down");
                $('.occassion-tile').removeClass('occassion-tile-scroll');

            } else {
                // Scrolling down
                if (!iscategoryImageInViewPort) {
                    $('.occassion-tile').addClass('occassion-tile-scroll');
                    categoriesContainer.addClass("hide-on-scroll-down");
                }
            }
            prevScrollpos = currentScrollPos;
        }, 500);
    });
    // end
    if (window.innerWidth < 992) {
        $('.secondary-bar.selected-list-box').hide();
        $('.refinements .filler-content .card-body').height($(window).height() - 160);
    }

    // Add minus icon for collapse element which is open by default
    $.fn.isInViewport = function () {
        if ($(this).length > 0) {
            let elementTop = $(this).offset().top;
            let elementBottom = elementTop + $(this).outerHeight();
    
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();
    
            return elementBottom > viewportTop && elementTop < viewportBottom;
        }
    };

    /**
     * Set Selected
     * @param {Object} obj url query number
     */
    function settoppos(obj) {
        const element = $(obj).parent().parent().find('.show-links .content');
        if (element.attr('data-attributeID') === 'size') {
            getObj = element;
            const cutoffThreshold = $(element).find('#cutoffThreshold').val();
            cutoffThresholds = cutoffThreshold - 1;
            const getAllfillter = $(element).find('#getAllfillter').val();
            var hideRow = getAllfillter - cutoffThreshold;
            $('.hidden-row').html(hideRow);
        }
    }
    $('.refinements .title.btn-link').each(function () {
        if ($(this).hasClass('open-block')) {
            $('this').trigger('click');
        }
        if (viewSize >= 992) {
            $('#refinements-size').addClass('show');
            $('.refinement-size').addClass('active');
            if ($(this).hasClass('open-block')) {
                $('.js_open_block').val($(this).parent().attr('id'));
            }
        }
    });
    // Toggle plus minus icon on show hide of collapse element
    $(document).on('click', '.refinements .title.btn-link', function () {
        $('.js_open_block').val($(this).parent().attr('id'));
        if (viewSize <= 992) {
            $('.refinements .title.btn-link').parent().next().hide();
            $(this).parent().next().show();
        }
    });
    $(document).on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').attr('style', 'display:block!important');
    });
    $(document).on('click', '.js-clear-all', () => {
        if (viewSize <= 992) {
            $('#refinements').addClass('open');
            $('.refinement-bar').show();
            $('.close-filter').attr('disabled', 'disabled');
            $('.plp-bottom-filter:not(.mobile-sort-by-button)').removeClass('active-button');
            $('.filter-bar button.reset').trigger('click');
        }
    });
    $('#close-popup, .close-filter').click(() => {
        if (viewSize <= 992) {
            $('.refinement-bar').hide();
            $('.refinement-bar, .modal-background').attr('style', 'display:none !important');
            $('body').attr('style', 'overflow:auto');
            if ($('.price-range-selector-active').length) {
                $('.btm-price-range').trigger('click');
            }

            if ($('.refinements .card').find('.title.btn-link h4.text-bold').length > 0) {
                $('.plp-bottom-filter:not(.mobile-sort-by-button)').addClass('active-button');
                $('.plp-bottom-filter:not(.mobile-sort-by-button)').find('.sub.text').text(`${$('.refinements .card').find('.title.btn-link h4.text-bold').length} ${$('.applied-filter-js').text()}`);
            } else {
                $('.plp-bottom-filter:not(.mobile-sort-by-button)').removeClass('active-button');
                $('.plp-bottom-filter:not(.mobile-sort-by-button)').find('.sub.text').text('Apply filter');
            }
            $('.plp-product-carousel-area').carousel({
                interval: false,
                pause: true,
                touch: true,
            });
        }
    });
    $(document).on('click', '.refinements.open .card-body ul li button', () => {
        if (viewSize <= 992) {
            $('.close-filter').removeAttr('disabled');
        }
    });
    $(document).on('click', '.close', () => {
        if (viewSize <= 992) {
            $('.filter-bar button.reset').trigger('click');
            $('.refinement-bar').hide();
        }
        if (sessionStorage.getItem('quickViewWishlist')) {
            sessionStorage.removeItem('quickViewWishlist');
            location.reload();
        }
    });

    if (viewSize <= 992) {
        $('#refinements').data('closedAll', true);
        $(document).on('click', '.refinements .title.btn-link', function () {
            $('#refinements').addClass('open');
            const ele = $(this);
            const settop = setTimeout(settoppos(ele), 500);
        });


        $(document).on('click', '#show-more', function () {
            $(getObj).find('.size-line-item').show();
            $(this).hide();
            $('#show-less').css('display', 'inline-block');
        });
        $(document).on('click', '#show-less', function () {
            $(getObj).find(`.size-line-item:gt(${cutoffThresholds})`).css('display', 'none');
            $(this).hide();
            $('#show-more').css('display', 'inline-block');
        });
        $(document).on('click', '.header-bar button', () => {
            $('.filter-bar button.reset').click();
        });
    }

    $(window).scroll(() => {
        let isInViewPort = $('.loadmoreproducts').isInViewport();
        if (isInViewPort) $('.show-more button').click();
    });

    $(document).on('click', '.secondary-bar .reset', () => {
        $('.js_open_block').val('heading-size');
    });
 
    $(document).on('click', '#refinements .card-header', () => {
        if ($('#refinements').hasClass('open')) {
            $('.header-bar .close.js-clear-all').show();
        } else {
            $('.header-bar .close.js-clear-all').hide();
        }
    });

    $(document).on('click', '#refinements .card.refinement', (e) => {
        let remainingFitler = $('#refinements .card.refinement');
        remainingFitler.removeClass('active');
        $(e.currentTarget).addClass('active');
    });

    $(document).on('click', '.mobile-sort-by-button', () => {
        $('.mobile-sort-by-list, .overlay').show();
    });

    $(document).on('click', '.close-sort-mobile-popup', () => {
        $('.mobile-sort-by-list, .overlay').hide();
    });

    $('.mobile-sort-by-list li:first-child').addClass('selected');
    $('.mobile-sort-by-list li:first-child').find('i').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
    
    $(document).on('click', '.mobile-sort-by-list li', function () {
        var selectedOption = $(this).data('id');
        var selectedClassName = $(`[data-id="${selectedOption}"]`);
        var urlValue = selectedClassName.val();
        var updatedOption = selectedClassName.find('span').text();
        $.spinner().start();
        $.ajax({
            url: urlValue,
            data: { selectedUrl: urlValue },
            method: 'GET',
            success(response) {
                $('.product-grid').empty().html(response);
                $('.mobile-sort-by-list li i').removeClass('fa-dot-circle-o').addClass('fa-circle-o');
                $('.mobile-sort-by-list li').removeClass('selected');
                selectedClassName.addClass('selected');
                selectedClassName.find('i').removeClass('fa-circle-o').addClass('fa-dot-circle-o');
                $('.mobile-sort-by-list, .overlay').hide();
                $('.mobile-sort-by-button span.sub.text').text(updatedOption);
                $.spinner().stop();
            },
            error() {
                $.spinner().stop();
            },
        });
    });

    var selectedFilter = 0;
    $('.refinements .card').each(function () {
        selectedFilter = $(this).find('.filler-content .nullselected, .filler-content .selected').length;
        if (selectedFilter !== 0) {
            $(this).find('.item-no').html(` (${selectedFilter})`);
            $(this).find('.item-no').attr('data-count', selectedFilter);
            $(this).find('.title.btn-link h4').addClass('text-bold selectedFilterTitle');
        }
    });

    var viewSizes = $(window).width();
    if (viewSizes <= 768) {
        $(".refinements .title.btn-link").each(function () {
            $('.refinements .title.btn-link').parent().next().hide();
            $(this).parent().next().show();
        });
    }
    function showHideReset() {
        var eleID = $('.js_open_block').val() + ' .title';
        var selectedFilter = 0;
        var selectedBlockID = " ";

        $('.refinements .card').each(function () {
            selectedFilter = $(this).find('.filler-content .nullselected, .filler-content .selected').length;
            if (selectedFilter !== 0) {
                $(this).find('.item-no').html(' (' + selectedFilter + ')');
                $(this).find('.item-no').attr('data-count', selectedFilter);
                $(this).find('.title.btn-link h4').addClass('text-bold selectedFilterTitle');
            }

            if ($('.js_price_change').val() == 'true') {
                $(this).find('.item-no.js-price-block').html('(1)');
            }
        });

        $('.' + eleID).trigger("click");
    }
    function checkSelectedElements() {
        const myTimeout = setTimeout(showHideReset, 500);
    }
    checkSelectedElements();
    if ($("#mydiv").length > 0) {
        var uptoDate = updateQueryStringParameter($('.js-reset-url').attr('data-href'), 'removePrice', 'true');
    }

    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }
    function updatePriceFilter() {
        var updateURL = $('.js-price-filter').attr('data-href');
        var min = $('.js-price-min').val();
        var max = $('.js-price-max').val();
        updateURL = updateUrlParameter(updateURL, 'pmin', min);
        updateURL = updateUrlParameter(updateURL, 'pmax', max);
        $('.js-btn-price-filter').attr('data-href',updateURL);
    }
    $(document).on('blur', '.js-price-min, .js-price-max', function () {
        updatePriceFilter();
    });
}
$(document).on('click', '.js-reset-filter', () => {
    $('.filter-bar button.reset').click();
});
function validatePriceRange () {
    var min = $('.js-price-min').val();
    var max = $('.js-price-max').val();
    var errorMsg="";
    if (parseInt(min) > parseInt(max)) {
        errorMsg = $('.js-error-price-filter').attr('data-error-min-max-price-filter');
        $('.js-error-price-filter').html(errorMsg);
        $('.js-error-price-filter').css('display','block'); 
        return false;
    } else if (parseInt(min) == parseInt(max)){
        errorMsg = $('.js-error-price-filter').attr('data-error-price-equel-filter');
        $('.js-error-price-filter').html(errorMsg);
        $('.js-error-price-filter').css('display','block'); 
        return false;       
    } else if (min=='' || max=='') {
        errorMsg = $('.js-error-price-filter').attr('data-error-price-filter');
        $('.js-error-price-filter').html(errorMsg);
        $('.js-error-price-filter').css('display','block');         
        return false;         
    } else {
        $('.js-error-price-filter').css('display','none');
        return true;
    }
}

/*
* Author :  Sanjeev Kumar Sharma
* Function: To handle search result section close and scroll on close button click
*/

function mainSearch(){
    $(document).on('click', '.site-search .reset-button', function () {
        $('.search .site-search .search-field').val('');
        $('.search-mobile .site-search .search-field').val('');
        $('.suggestions').hide();
        $('.reset-button').addClass('d-none').removeClass('d-sm-block');
        $('.homepage header').removeClass('active');
        $('body').removeClass('modal-open');
    });

    $(".site-search .search-field").focusin(function() {
        $('.homepage header').addClass('active');
    }).focusout(function () {
        var s = $('.search .site-search .search-field').val() || $('.search-mobile .site-search .search-field').val();
        if(s.length==0){
            $('.homepage header').removeClass('active');
        }
    });


}

$(document).on('show.bs.collapse', '#refinements .collapse', function (e) {
    let actives = $('#refinements').find('.filler-content, .collapsing');
    actives.each( function (index, element) {
        $(element).collapse('hide');
    })
})

$(document).on('click', '.reset-button, .navbar-toggler', function() {
    $('body').removeClass('no-scroll');
});
//  function onPopState() {
     window.addEventListener('popstate', function () {
        if (sessionStorage.getItem('url')) {
            window.location = sessionStorage.getItem('url');
        } else {
            window.location.reload();
        }
     });
     
     $(window).on('load', function(){
        var pid = sessionStorage.getItem('pid');
        if(pid){
            var tile = $('.product-tile[data-pid="' + pid + '"]');
            if(tile.length) {
                var scroll = tile.offset().top - $('header').height()
                var top = $('.hide-on-scroll-down').is(':visible') ? scroll - $('.hide-on-scroll-down').height() : scroll
                $('html, body').animate({
                    scrollTop : top - 100
                }, 300);
                sessionStorage.removeItem('pid');
                sessionStorage.removeItem('url');
            }
        }
    });
    
$('.product-tile[data-producturl]').on('click', function(e) {

    if( $(window).width() < 769 ) {
        var pid = $(this).attr('data-pid');
        var productUrl = $(this).attr('data-producturl');
        var url = window.location;
        sessionStorage.setItem('pid', pid);
        sessionStorage.setItem('url', url);
    }


})

searchComponent.sort = sort;
searchComponent.showMore = showMore;
searchComponent.applyFilter = applyFilter;
searchComponent.clickEvents = clickEvents;
searchComponent.showContentTab = showContentTab;
searchComponent.mainSearch = mainSearch;
searchComponent.resize = resize;

module.exports = searchComponent;
